import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';

import s from './ViewMessage.css';
import ViewMessage from '../../components/ViewMessage';

class ViewMessageContainer extends React.Component {
  static propTypes = {
    threadId: PropTypes.number.isRequired,
    userType: PropTypes.string.isRequired,
    isAuthenticated: PropTypes.bool,
    isAdminAuthenticated: PropTypes.bool
  };
  
  render() {
    const { threadId, userType } = this.props;

    return (
      <div>
        <div className={s.container}>
          <div className={s.root}>
            <ViewMessage threadId={threadId} userType={userType} />
          </div>
        </div>
      </div>
    );
  }
}

const mapState = (state) => ({
  isAuthenticated: state.runtime.isAuthenticated,
  isAdminAuthenticated: state.runtime.isAdminAuthenticated
});

export default connect(mapState)(withStyles(s)(ViewMessageContainer));